/**
 * @hidden
 */
export function getHoverOpenDelay(props) {
    if (props.hoverOpenDelay !== undefined) {
        return props.hoverOpenDelay;
    }
    else {
        return props.openOnClick ? 0 : 100;
    }
}
/**
 * @hidden
 */
export function getHoverCloseDelay(props) {
    return props.hoverCloseDelay !== undefined ? props.hoverCloseDelay : 100;
}
//# sourceMappingURL=hoverDelay.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-layout/dist/es/menu/utils/hoverDelay.js
// module id = 361
// module chunks = 0